import React from "react";
import { Button, Modal } from "react-bootstrap";

import useRosterHandlers from "../hooks/useRosterHandlers";
import { DeletePlayerModalProps } from "../types/player";

import { defaultDateFormat } from "../../../../../lib/utils";

const DeletePlayerModal = (
    props: DeletePlayerModalProps,
): React.JSX.Element => {
    const { player, showDeleteModal, setShowDeleteModal } = props;
    const { handleDelete } = useRosterHandlers();

    return (
        <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
            data-testid="deletePlayerModal"
        >
            <Modal.Header>
                <Modal.Title>Delete player?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <b>Are you sure you want to delete this player?</b>
                <br />
                {player?.firstName} {player?.lastName}
                <br />
                {player?.dob
                    ? defaultDateFormat.format(
                          new Date(`${player.dob}T00:00:00`),
                      )
                    : ""}
                <br />
                {player?.email}
                <br />
                <br />
                <b>Note:</b> Deleting this player will remove them from your
                team and could affect their playoff eligibility. If you'd like
                to keep them on your team and maintain their eligibility (if
                applicable), instead set them to an "Inactive" status.
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={() => setShowDeleteModal(false)}
                >
                    No
                </Button>
                <Button variant="danger" onClick={() => handleDelete(props)}>
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeletePlayerModal;
